// extracted by mini-css-extract-plugin
export default {"addToCartControl":"d2-z","giftCard":"e2-z","btnContainer":"f2-z","cartButton":"g2-z","disabled":"h2-z"};